import { getApiErrorMessage } from '@api/getApiError';
import { locationSlice } from '@api/Trinium/Endpoints/Location/slice';
import { City } from '@api/Trinium/Endpoints/Location/types';
import { PagedResponse } from '@api/Trinium/types';
import { FormikButtonDropdown } from '@forms/Components/Dropdowns/ButtonDropdown';
import SearchablePopupContent from '@forms/Components/Dropdowns/SearchablePopupContent';
import { store } from '@reduxStore';
import { Field, useFormikContext } from 'formik';

interface CityDropdownFieldProps {
	fieldName: string;
	className?: string;
	disabled?: boolean;
}

export default function CityDropdownField(props: CityDropdownFieldProps) {
	const { getFieldMeta } = useFormikContext();
	const { value } = getFieldMeta<City>(props.fieldName);

	return (
		<Field
			name={props.fieldName}
			label='City'
			className={props.className}
			component={FormikButtonDropdown({
				ButtonContent: ({ city }: { city?: City }) => {
					return <span>{city?.name ?? 'Select a City'}</span>;
				},
				buttonContentProps: {
					city: value
				},
				PopupContent: SearchablePopupContent,
				popupContentProps: {
					onSearchCallback: onCitySearch,
					getOptionText: getCityItemText
				}
			})}
			disabled={props.disabled}
		/>
	);
}

/**
 * Callback for the Button Popup Content to display the city as a list item
 */
const getCityItemText = (city: City) => `${city.name} (${city.id})`;

/**
 * Callback for the Button Popup Content to search when the user types into the input
 */
const onCitySearch = (searchValue: string, page: number) => {
	return new Promise<PagedResponse<City>>((resolve, reject) => {
		store
			.dispatch(locationSlice.endpoints.fetchCities.initiate({ contains: searchValue, page }, { subscribe: false }))
			.unwrap()
			.then((response) => {
				resolve(response);
			})
			.catch((error: unknown) => {
				const deserializedError = getApiErrorMessage(error);
				reject(new Error(deserializedError));
			});
	});
};
